export default "__VITE_ASSET__CZXkCTq2__"